
import React, { useState } from "react";
import './SubmitRequest.css';
import contactImage from '../../assest/ExamSify Contact Image.png';

const SubmitRequest = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [status, setStatus] = useState("");
  const [formData, setFormData] = useState({
    submitname: "",
   submitemail: "",
   submitphone: "",
   submituserType: "teacher",
    submitcategory: "Request Solutions",
  submitmessage: ""
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(formData.submitphone)) {
      setStatus('Please enter a valid 10-digit mobile number.');
      return;
    }
    setShowPopup(true);

    try {
    //const res = await fetch("http://localhost:8004/api/submit-request", { //Uncomment this line if you have a backend server running locally
    const res = await fetch("https://cz-engine.onrender.com/api/submit-request", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    const result = await res.json();
    if (res.ok) {
      

      //  Clear the form
      setFormData({
        submitname: "",
        submitemail: "",
        submitphone: "",
        submituserType:"teacher",
        submitcategory: "Request Solutions",
        submitmessage: ""
      });
    } else {
      alert("Error: " + result.error);
    }
  } catch (err) {
    console.error(err);
    alert("Something went wrong!");
  }
  };

  return (
    <div className="exam-contact-container">
      <div className="exam-contact-left">
        <img src={contactImage} alt="Contact" />
      </div>
      <div className="exam-contact-right">
        <h1 className="exam-contact-heading">Submit Request</h1>
        <div className="exam-contact-form-wrapper">
          <form className="exam-contact-form" onSubmit={handleSubmit}>
            <div className="exam-contact-group">
              <label htmlFor="name">Your Name</label>
              <input className="exam-contact-input" type="text" id="submitname" placeholder="Enter Name" value={formData.submitname} onChange={handleChange} required/>
            </div>

            <div className="exam-contact-group">
              <label htmlFor="email">Your Email</label>
              <input className="exam-contact-input" type="email" id="submitemail" placeholder="Email address" value={formData.submitemail} onChange={handleChange} required />
            </div>

            <div className="exam-contact-group">
              <label htmlFor="phone">Cell Number</label>
              <input className="exam-contact-input" type="tel" id="submitphone"placeholder="Enter a number" value={formData.submitphone}  onChange={(e) => {
                handleChange(e);
                setStatus("");
              }}
              required
            />
            {status && <p className="error-msg">{status}</p>} 
            </div>
             <fieldset>
          <legend>Are You ?</legend>
          <label className='contact-label'>
            <input
              type="radio"
              name="submituserType"
                  id='submituserType'
              value="parent"
              checked={formData.submituserType=== "parent"}
              onChange={handleChange}
            />{" "}
            A Parent
          </label>
       <label className='contact-label'>
            <input
              type="radio"
              name="submituserType"
                  id='submituserType'
              value="student"
              checked={formData.submituserType === "student"}
              onChange={handleChange}
            />{" "}
            A Student
          </label>
         <label className='contact-label'>
            <input
              type="radio"
              id='submituserType'
              name="submituserType"
              value="teacher"
              checked={formData.submituserType === "teacher"}
              onChange={handleChange}
            />{" "}
            A Teacher
          </label>
        </fieldset>

            <div className="exam-contact-group">
              <label htmlFor="category">Request Type</label>
              <select className="exam-contact-input" id="submitcategory" value={formData.submitcategory} onChange={handleChange}>
                <option>Request Solutions</option>
                <option>Request Questions</option>
                <option>Request new Feature</option>
                <option>Others request</option>
              </select>
            </div>

            <div className="exam-contact-group">
              <label htmlFor="message" >Explain Your Request</label>
              <textarea id="submitmessage" className="exam-contact-input" placeholder="Please summarise the problem" value={formData.submitmessage} onChange={handleChange} required></textarea>
            </div>

            <div className="exam-contact-actions">
              <button type="button" className="exam-contact-btn-cancel">Cancel</button>
              <button type="submit" className="exam-contact-btn-submit">Submit</button>
            </div>
          </form>
        </div>
      </div>
        {showPopup && (
<div className="submit-popup-overlay">
<div className="submit-popup-box">
  <h2>Thank you!</h2>
  <p>Thank you for contacting Examsify</p>
  <button className='submit-popup-button' onClick={() => setShowPopup(false)}>Close</button>
</div>
</div>
)}
    </div>
  );
};

export default SubmitRequest;
